export default __webpack_public_path__ + "static/staking-icon-98f4678f5befd06e774ad2bc1466ceff.svg";